import React, { useState, useEffect } from 'react';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

 
import useTable from "../../useTable";
import { ModalContribuyenteApuesta } from './modalContribuyenteApuesta';
import { ModalIncluirApuesta } from './modalIncluirApuesta';

function TablaDatosApuestas() {

    const headCells = [
        { id: '', label: 'CODIGO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: '', label: 'DESCRIPCION', width: '200px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: '', label: 'ALICUOTA', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: '', label: 'MONTO O CANTIDAD', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: '', label: 'MONTO A PAGRA', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: '', label: '', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },

    ]

    /* variables de estado */
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar6, setContar6] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [comercio, setComercio] = useState();
    const [persona, setPersona] = useState();
    const [statusCome, setStatusCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [ipMac, setIpMac] = useState({ ip: localStorage.getItem('ip'), mac: localStorage.getItem('mac') });
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();
    const [horaope, setHoraope] = useState();
    const [declaWeb, setDeclaWeb] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mostarModal, setMostrarModal] = useState(false);

    const abrirContri = () => {
        setMostrarModal(true);
    }

    const cerrarContri = () => {
        setMostrarModal(false);
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    /* metodo para filtrar la tabla */
    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idagenteretencion.includes(target.value)
                            || x.ritm.toLowerCase().includes(target.value.toLowerCase())
                            || x.rif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.reprelegal.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    };

  


    /* metodo para cerrar el dialogo de mensaje */

    const handleCloseMensa = () => {
        setMostrar(false);
    }


    /* metodo para cargar todos los agentes */

    const seleccionarComercios = () => {
        setContar4(0);
        setContar(0);
        setActivate(true);
     
    };


    /* metodo para cargar los estatus */

    const seleccionarStatus = () => {
        setContar2(0);
        setContar(0);
      
    };


    /* metodo para cargar la configuracion de la industria (alcaldia) */

    const seleccionarConfiguracion = () => {
        setContar(0);
       
    };


    
    /* metodo para abrir el modal y modificar un agente */

    const editarComercio = (item, index) => (event) => {

        event.preventDefault();
        setMostrar5('true')
    };


   

    const cerrarModalActualizar = () => {


        setMostrar5(false);

    }

    useEffect(() => {
       

    }, []);

    

    return (
        <div className="card">
            <ModalIncluirApuesta
                show={mostarModal}
                onHideCancela={cerrarContri}

            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            {/* /.card-header */}
            <div className="card-body">
                <div className="content" >
                    <div className="">

                        <div className="row col-md-12 mx-auto">

                            <div className="col-md-10" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idagenteretencion} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "10px" }}>{item.idagenteretencion}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "300px" }}>{item.nombre}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.ritm}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.rif}</td>

                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.reprelegal}</td>

                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }} /* onClick={eliminarComercio(item, index)} */ className="btn  btn-outline-danger"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>




                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                            <div className='col-md-2'>

                                <div className="col-md-12">
                                    <button /* disabled={permiso && permiso.substring(1, 2) !== "1"} */ /* onClick={agregarComercio} */ style={{ marginBottom: "10px" }} onClick={abrirContri} className="btn col-md-12 btn-outline-primary"><i className="fas fa-plus"><small>Incluir</small></i> </button>
                                </div>

                            </div>
                        </div>
                        <div className="row col-md-12 mx-auto justify-content-end" style={{ margin: 0, padding: 0 }}>
                            <div className="row col-md-2 " style={{ margin: '1%', padding: 0 }}>
                                <div className="col-md-8 text-dark" style={{ margin: 0, padding: 0 }}>
                                    Monto por Pagar:
                                </div>
                                <div className="col-md-4" style={{ margin: 0, padding: 0 }}>
                                    <input type="text" disabled={operacion === 1 ? true : deshabilitado} /* ref={txtRitm} */ className="form-control form-control-sm" /* defaultValue={props.comercio ? props.comercio.ritm.trim() : ''}  */id="inputRitm" /* onKeyUp={handleInputChange} onBlur={handleInputChange} */ />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">



                </div>
            </div>

        </div>

    );

}

export default TablaDatosApuestas;
